let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cPL6U")).then(() => parcelRequire('lR3O2'));